import React from "react";
import { Link } from "gatsby";

import StarIcon from "../../assets/images/star-icon.png";
import zhaopin from "../../assets/images/home/intro-of-hr/zhaopin.png";
import renshi from "../../assets/images/home/intro-of-hr/renshi.png";
import kaoqin from "../../assets/images/home/intro-of-hr/kaoqin.png";
import jixiao from "../../assets/images/home/intro-of-hr/jixiao.png";
import xinchou from "../../assets/images/home/intro-of-hr/xinchou.png";
import peixun from "../../assets/images/home/intro-of-hr/peixun.png";
import zuzhi from "../../assets/images/home/intro-of-hr/zuzhi.png";
import rencai from "../../assets/images/home/intro-of-hr/rencai.png";

const IntroOfHr = () => {
  const data = [
    {
      img: zhaopin,
      title: "智能招聘",
      desc: "从招聘计划到实施的全流程自动化，有效规避低效沟通，借助岗位智能筛选技术，消除重复性劳动。通过一键发布招聘岗位，极大节省了时间与人力。我们还提供预入职功能，进一步优化招聘体验。",
      to: "/recruitment",
      icon: "flaticon-laptop",
    },
    {
      img: renshi,
      title: "基础人事",
      desc: "通过智能流程全面替代繁琐的纸质操作，高效管理人事各项基础业务。模块涵盖了人事档案管理、劳动合同签署、人事调动安排、离职流程处理、人事异动数据深度分析及社保管理。",
      to: "/employee",
      icon: "flaticon-team",
    },
    {
      img: kaoqin,
      title: "排班考勤",
      desc: "灵活的考勤休假系统，为企业提供了便捷、高效且个性化的考勤与休假管理方案。支持复杂考勤排班管理，智能化排班，自动跳过节假日。出差管理，加班管理，异地打卡等功能，让多样化企业管理策略落地。",
      to: "/attendance",
      icon: "flaticon-stopwatch",
    },
    {
      img: jixiao,
      title: "绩效考评",
      desc: "以精准可靠的绩效计算能力脱颖而出。内置了多种主流绩效模板，帮助您快速应用。支持混合绩效模式，如kpi+kpr、kpi+360等，让您的企业绩效软件与管理制度完美联动。",
      to: "/performance",
      icon: "flaticon-book",
    },
    {
      img: xinchou,
      title: "薪酬核算",
      desc: "实现算薪算税流程一体化，系统支持企业多部门多种薪酬方案计算，系统内置多种调薪规则，智能识别并驳回不合理的调薪请求，让薪酬管理更加科学、合理。",
      to: "/salary",
      icon: "flaticon-money",
    },
    {
      img: peixun,
      title: "企业内训",
      desc: "系统集成在线培训管理与线下培训管理。通过完善的培训计划管理、专业的培训讲师资源库、丰富的培训课程选择，以及精准的培训效果评估，为企业提供全方位的培训支持。",
      to: "/training",
      icon: "flaticon-analysis",
    },
    {
      img: zuzhi,
      title: "编制预算",
      desc: "大任组织管理模块轻松驾驭复杂的集团架构，更能实现行政与虚拟架构的并行管理，助力企业业务流程高效流转。系统还能精准采集并核算历史编制成本，智能产出岗位编制预算。",
      to: "/organization",
      icon: "flaticon-analysis",
    },
    {
      img: rencai,
      title: "人才测评",
      desc: "以AI智能技术为核心，精准盘点并识别企业人才。支持人才轮岗培养记录，激发员工潜能。可为关键人才量身打造专属培养方案，助推他们迅速崭露头角。",
      to: "/develop",
      icon: "flaticon-analysis",
    },
  ];
  return (
    <section className="solutions-area pt-70" id="IntroOfHr">
      <div className="container">
        <div className="section-title">
          <span className="sub-title">
            <img src={StarIcon} alt="image" />
            eHR
          </span>
          <h2>人力资源管理系统</h2>
          <p>定制化HR软件，精准满足企业独特需求，成为推动业务飞跃的强大引擎</p>
        </div>

        <div className="row">
          {data.map((item, key) => (
            <div
              className="col-lg-3 col-sm-6 cursor-pointer"
              key={key}
              onClick={e => {
                e.preventDefault();
                window.___navigate(item.to);
              }}
            >
              <div className="single-process-box">
                <div className="number">{key + 1}</div>
                <div className="image">
                  <img src={item.img} alt="about" style={{ height: 200 }} />
                </div>
                <Link
                  to={item.to}
                  style={{
                    color: "#000",
                    fontSize: 20,
                    fontWeight: 600,
                    display: "block",
                    marginBottom: 10,
                    textDecoration: "none",
                  }}
                >
                  {item.title}
                </Link>
                <p style={{ height: 187 }}>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IntroOfHr;
